import FullWidthLayout from "@/layouts/FullWidthLayout";
import KPricingHelpList from "kinnect-front/KPricingHelp/KPricingHelpList";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { PricingHelp } from "kinnect-models";
import { VCard, VCardText, VSheet } from "vuetify/lib";

export default {
	name: "PricingHelpListPage",

	metaInfo: { title: "Pricing Help & Logins" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		pricingHelpItems: [],
		search: ""
	} ),

	computed: {
		numItems() {
			return this.pricingHelpItems.length;
		},

		toolbarActions() {
			return {
				icon: "add_circle",
				text: "Add Help / Login",
				to: { name: "pricingHelpAdd" },
				tooltip: "Add pricing help / login"
			};
		}
	},

	watch: {
		numItems( numItems ) {
			this.$store.dispatch( "breadcrumbs/setDetails", `${numItems} items` );
		}
	},

	methods: {
		async fetchPricingHelpItems() {
			this.pricingHelpItems = await PricingHelp.get();
		},

		async fetch() {
			await this.fetchPricingHelpItems();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<VCardText>
					<KPricingHelpList
						items={this.pricingHelpItems}
						loading={this.$wait.is( "get pricing help list" )}
						search={this.search}
					></KPricingHelpList>
				</VCardText>
			</VCard>
		</FullWidthLayout>;
	}
};
